module.exports = __webpack_public_path__ + "img/VideoCamera.8ecdcd67.svg";